import type { PackageType } from "@prisma/client";

/** Maps landing UI labels to Prisma `PackageType` for brief checkout. */
export const LANDING_PLAN_TO_PACKAGE: Record<string, PackageType> = {
  "Landing page": "LANDING_PAGE",
  "Branding Package": "BRAND_PACKAGE",
  "Basic MVP": "BASIC_MVP",
  "Advanced MVP": "ADVANCED_MVP",
};

export function packageTypeForLandingPlan(
  key: string,
): PackageType | null {
  return LANDING_PLAN_TO_PACKAGE[key] ?? null;
}
